<template>
    <div class="grid grid-cols-5 mt-10 md:mt-1 text-center md:text-start">
        <div class="col-span-5 lg:col-span-3 lg:pe-40">
            <div class="text-4xl md:text-5xl font-bold head">
                Welcome Home! <br> 
                <span class="text-orange-500 font-bold">A Place</span> to Belong!
            </div>
            <div class="my-8 text-lg">
                <!-- We are <strong>The Saints Gathering Church</strong>. We have taken on that Global Mandate of Jesus Christ to preach the gospel, disciple men and demonstrate the power of God. We believe that God's greatest desire is to see all men saved and so we are focused on raising men to carry out God's vision. Come and join us in fulfilling this vision of taking the Gospel of Jesus to the uttermost ends of the earth. -->

                We are The Saints Gathering Church. A body of passionate believers in the gospel of Jesus. 

                We have a mandate to <strong>preach the gospel</strong>, <strong>raise disciples</strong>, and <strong>demonstrate the power of God</strong> everywhere we go. 

                We want to fulfill God’s desire of having all men saved and we live to plunder hell and populate heaven for the one true King, Jesus.

                Stick around, and in no time, you’ll be part of the army. 

            </div>
        </div>

        <div class="hidden lg:flex relative justify-end me-10">
            <img src="../../assets/images/about_image_one.png" class="rounded absolute top-24 h-5/6" alt="">
        </div>

        <div class="hidden lg:flex">
            <img src="../../assets/images/about_image_two.png" class="rounded h-5/6" alt="">
        </div>
    </div>
</template>

<script setup>
import PrimaryButton from '../PrimaryButton.vue'
</script>

<style scoped>

</style>